import ReactCursorPosition from 'react-cursor-position';
import {Box, Center, SimpleGrid, Spinner, Text} from '@chakra-ui/react';
import React, {useState} from 'react';
import Map from '../Common/map';
import colorAlpha from 'color-alpha';
import Container from "../../../components/Container";

const ContactList = ({data}) => {
    if (!data) {
        return (
            <Box my={20}>
                <Spinner color='blue.600' size='xl'/>
            </Box>
        )
    }
    return (
        <>
            <Box borderX={'1px'} borderColor={'brandAlpha.200'} as="section">
                <Box px={'1rem'}>
                    <Container>
                        <SimpleGrid
                            columns={[1, 1, 2, 2, 2]}
                            spacingX="21px"
                            spacingY="60px"
                            pb={'120px'}
                        >
                            {data.map((loc) => {
                                return <TeamItem key={loc.title} {...loc} />;
                            })}
                        </SimpleGrid>
                    </Container>
                </Box>
            </Box>
        </>
    );
};

export default ContactList;

const TeamItem = (props) => {
    const {title, address, phone} = props;
    const [{x, y}, setMouseCoordinates] = useState({x: 0, y: 0});
    return (
        <Box>
            <Box position={'relative'}>
                <a href={(props.map_url ? props.map_url : `https://www.google.com/maps/search/?api=1&query=${props.latitude},${props.longitude}`)}
                   target="_blank"
                   rel="noopener noreferrer">
                    <ReactCursorPosition
                        onPositionChanged={({position: {x, y}}) => {
                            setMouseCoordinates({x, y});
                        }}
                    >
                        <Box
                            _hover={{
                                '& #overlay': {
                                    opacity: 1,
                                    transition: '150ms all ease',
                                },
                                '&:before': {
                                    content: "''",
                                    position: 'absolute',
                                    width: '100%',
                                    left: 0,
                                    height: '1px',
                                    backgroundColor: 'white',
                                    opacity: 0.2,
                                    top: y,
                                    zIndex: 9999999999,
                                },
                                '&:after': {
                                    content: "''",
                                    position: 'absolute',
                                    height: '100%',
                                    top: 0,
                                    width: '1px',
                                    backgroundColor: 'white',
                                    opacity: 0.2,
                                    left: x,
                                    zIndex: 9999999999,
                                },
                            }}
                            userSelect={'none'}
                            position={'relative'}
                            top="0"
                        >
                            {x > 70 && y > 40 && y < 350 && (
                                <Text
                                    fontSize={'sm'}
                                    letterSpacing={'-1px'}
                                    lineHeight={'14px'}
                                    as={'span'}
                                    position={'absolute'}
                                    top={y + 7}
                                    left={x - 70}
                                    id={'overlay'}
                                    opacity={0}
                                    color={'white'}
                                    userSelect={'none'}
                                    zIndex={9999999999}
                                >
                                    View on maps
                                </Text>
                            )}
                            <Center
                                minH={['315px', '315px', '315px', '315px', '426px']}
                                mb={'0.625rem'}
                                width={'100%'}
                                position={'relative'}
                            >
                                <Box positon="absolute" width="100%" height='100%' top="0"  style={{position: 'absolute'}}>
                                    <Map {...props} />
                                </Box>
                            </Center>
                            <Box
                                id={'overlay'}
                                position={'absolute'}
                                inset={0}
                                px={'20px'}
                                py={'15px'}
                                bgColor={'brandAlpha.600'}
                                opacity={0}
                            />
                        </Box>
                    </ReactCursorPosition>
                </a>
            </Box>
            <Box mt={'40px'} maxW={'280px'}>
                <Text
                    fontWeight={'semibold'}
                    fontSize={['30px', '3rem']}
                    lineHeight={['33px', '3rem']}
                    letterSpacing={'-2px'}
                    textAlign={'left'}
                    mb={'40px'}
                >
                    {title}
                </Text>
                <Text
                    fontSize={'16px'}
                    lineHeight={['24px', '20.8px']}
                    textAlign={'left'}
                    mb={'20px'}
                    dangerouslySetInnerHTML={{
                        __html: address,
                    }}
                />
                <Box display={'flex'} flexDirection={'column'}>
                    <Text
                        fontSize={'8px'}
                        lineHeight={'10.4px'}
                        textAlign={'left'}
                        textColor={colorAlpha('#000', 0.5)}
                        as="span"
                        mb={'4px'}
                    >
                        PHONE
                    </Text>
                    <Text
                        fontSize={'16px'}
                        lineHeight={'24px'}
                        textAlign={'left'}
                        as={'a'}
                        href={'tell:6505619580'}
                    >
                        {phone}
                    </Text>
                </Box>
            </Box>
        </Box>
    );
};
